import Header from '../../components/feature/Header';
import { Link } from 'react-router-dom';

export default function TokushohoPage() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 px-8 bg-gradient-to-br from-[#f5f3f0] via-white to-white">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center gap-2 mb-6">
            <div className="w-2 h-2 bg-[#1a2332] rotate-45"></div>
            <span className="text-sm font-medium text-[#1a2332] uppercase tracking-wider">Legal Information</span>
          </div>
          <h1 className="text-5xl font-bold text-[#1a2332] mb-6">特定商取引法に基づく表記</h1>
          <p className="text-lg text-[#4a5568]">
            特定商取引法に基づき、以下の通り表記いたします。
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 px-8">
        <div className="max-w-4xl mx-auto">
          <div className="space-y-12">
            {/* 販売事業者 */}
            <div className="pb-8 border-b border-[#e2e8f0]">
              <h2 className="text-2xl font-bold text-[#2d3748] mb-4">販売事業者</h2>
              <p className="text-[#4a5568] leading-relaxed">Trim-Page</p>
            </div>

            {/* 運営統括責任者 */}
            <div className="pb-8 border-b border-[#e2e8f0]">
              <h2 className="text-2xl font-bold text-[#2d3748] mb-4">運営統括責任者</h2>
              <p className="text-[#4a5568] leading-relaxed">山田 太郎</p>
            </div>

            {/* 所在地 */}
            <div className="pb-8 border-b border-[#e2e8f0]">
              <h2 className="text-2xl font-bold text-[#2d3748] mb-4">所在地</h2>
              <p className="text-[#4a5568] leading-relaxed">
                〒150-0001<br />
                東京都渋谷区神宮前1-2-3 サンプルビル4F
              </p>
              <p className="text-sm text-[#4a5568] mt-3">
                ※お客様の個人情報保護の観点から、お電話でのお問い合わせは受け付けておりません。お問い合わせはメールにてお願いいたします。
              </p>
            </div>

            {/* 連絡先 */}
            <div className="pb-8 border-b border-[#e2e8f0]">
              <h2 className="text-2xl font-bold text-[#2d3748] mb-4">連絡先</h2>
              <div className="space-y-2">
                <div>
                  <span className="text-sm font-medium text-[#2d3748]">メールアドレス：</span>
                  <a href="mailto:info@trim-page.com" className="text-[#4a5568] hover:text-[#1a2332] transition-colors">
                    info@trim-page.com
                  </a>
                </div>
                <p className="text-sm text-[#4a5568] mt-3">
                  ※お問い合わせへの返信は、原則として2営業日以内に行います。
                </p>
              </div>
            </div>

            {/* 販売価格 */}
            <div className="pb-8 border-b border-[#e2e8f0]">
              <h2 className="text-2xl font-bold text-[#2d3748] mb-4">販売価格</h2>
              <div className="space-y-4">
                <div className="bg-[#f5f3f0] p-6 rounded-lg">
                  <h3 className="font-bold text-[#2d3748] mb-3">基本制作</h3>
                  <p className="text-[#4a5568]">¥30,000（税込）</p>
                  <p className="text-sm text-[#4a5568] mt-2">1ページの静的サイト制作、レスポンシブデザイン対応、Cloudflare Pages設定、基本的なSEO対策を含みます。</p>
                </div>

                <div className="bg-[#f5f3f0] p-6 rounded-lg">
                  <h3 className="font-bold text-[#2d3748] mb-3">オプション料金</h3>
                  <ul className="space-y-2 text-[#4a5568]">
                    <li className="flex items-start gap-2">
                      <span className="font-medium min-w-[200px]">ページ追加オプション：</span>
                      <span>¥10,000/ページ（税込）</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="font-medium min-w-[200px]">フォーム連携オプション：</span>
                      <span>¥10,000/フォーム（税込）</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="font-medium min-w-[200px]">CMS連携オプション：</span>
                      <span>¥10,000（税込）</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="font-medium min-w-[200px]">GitHub支援オプション：</span>
                      <span>¥10,000（税込）</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="font-medium min-w-[200px]">microCMS支援オプション：</span>
                      <span>¥10,000（税込）</span>
                    </li>
                  </ul>
                </div>

                <p className="text-sm text-[#4a5568]">
                  ※上記価格は全て税込表示です。<br />
                  ※ドメイン費用（年間¥1,000〜¥2,000程度）は別途お客様の実費負担となります。<br />
                  ※外部サービス（microCMS等）のご利用料金は別途発生する場合があります。
                </p>
              </div>
            </div>

            {/* 支払方法 */}
            <div className="pb-8 border-b border-[#e2e8f0]">
              <h2 className="text-2xl font-bold text-[#2d3748] mb-4">支払方法</h2>
              <div className="space-y-3">
                <p className="text-[#4a5568]">以下のお支払い方法をご利用いただけます。</p>
                <ul className="space-y-2 ml-6">
                  <li className="flex items-start gap-2">
                    <div className="w-2 h-2 bg-[#2d3748] rounded-full flex-shrink-0 mt-2"></div>
                    <span className="text-[#4a5568]">銀行振込（前払い）</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <div className="w-2 h-2 bg-[#2d3748] rounded-full flex-shrink-0 mt-2"></div>
                    <span className="text-[#4a5568]">クレジットカード決済</span>
                  </li>
                </ul>
                <p className="text-sm text-[#4a5568] mt-3">
                  ※銀行振込の場合、振込手数料はお客様のご負担となります。<br />
                  ※お支払い確認後、制作作業を開始いたします。
                </p>
              </div>
            </div>

            {/* 引渡時期 */}
            <div className="pb-8 border-b border-[#e2e8f0]">
              <h2 className="text-2xl font-bold text-[#2d3748] mb-4">サービス提供時期</h2>
              <div className="space-y-3">
                <p className="text-[#4a5568]">
                  ご入金確認後、通常2〜4週間程度でサイトを納品いたします。
                </p>
                <p className="text-sm text-[#4a5568]">
                  ※制作内容やオプションの有無により、納期は前後する場合があります。<br />
                  ※詳細な納期については、お見積もり時に個別にご案内いたします。
                </p>
              </div>
            </div>

            {/* 返品・キャンセルポリシー */}
            <div className="pb-8 border-b border-[#e2e8f0]">
              <h2 className="text-2xl font-bold text-[#2d3748] mb-4">返品・キャンセルポリシー</h2>
              <div className="space-y-4">
                <div>
                  <h3 className="font-bold text-[#2d3748] mb-2">制作開始前のキャンセル</h3>
                  <p className="text-[#4a5568]">
                    制作作業開始前（ご入金前）であれば、キャンセル料は発生いたしません。
                  </p>
                </div>

                <div>
                  <h3 className="font-bold text-[#2d3748] mb-2">制作開始後のキャンセル</h3>
                  <p className="text-[#4a5568] mb-2">
                    制作作業開始後のキャンセルにつきましては、以下のキャンセル料が発生いたします。
                  </p>
                  <ul className="space-y-2 ml-6">
                    <li className="flex items-start gap-2">
                      <div className="w-2 h-2 bg-[#2d3748] rounded-full flex-shrink-0 mt-2"></div>
                      <span className="text-[#4a5568]">制作開始〜中間確認前：契約金額の50%</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <div className="w-2 h-2 bg-[#2d3748] rounded-full flex-shrink-0 mt-2"></div>
                      <span className="text-[#4a5568]">中間確認後〜納品前：契約金額の80%</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <div className="w-2 h-2 bg-[#2d3748] rounded-full flex-shrink-0 mt-2"></div>
                      <span className="text-[#4a5568]">納品後：返金不可</span>
                    </li>
                  </ul>
                </div>

                <div>
                  <h3 className="font-bold text-[#2d3748] mb-2">返品について</h3>
                  <p className="text-[#4a5568]">
                    本サービスはデジタルコンテンツの制作サービスであり、商品の性質上、納品後の返品・返金には応じかねます。ただし、当方の責に帰すべき重大な瑕疵がある場合は、個別に協議の上、対応させていただきます。
                  </p>
                </div>

                <p className="text-sm text-[#4a5568] bg-[#f5f3f0] p-4 rounded-lg">
                  ※制作途中での仕様変更や大幅な修正依頼は、追加料金が発生する場合があります。<br />
                  ※お客様都合による制作の長期中断（1ヶ月以上）が発生した場合、それまでの作業分を請求させていただく場合があります。
                </p>
              </div>
            </div>

            {/* 瑕疵担保責任 */}
            <div className="pb-8 border-b border-[#e2e8f0]">
              <h2 className="text-2xl font-bold text-[#2d3748] mb-4">瑕疵担保責任</h2>
              <div className="space-y-3">
                <p className="text-[#4a5568]">
                  納品後1ヶ月間は、制作物に重大な瑕疵（表示不具合、リンク切れ等）があった場合、無償で修正対応いたします。
                </p>
                <p className="text-sm text-[#4a5568]">
                  ※軽微な修正や仕様変更は、無償サポート期間内であっても対応範囲外となる場合があります。<br />
                  ※お客様の環境や外部サービスの仕様変更に起因する不具合は、瑕疵担保の対象外となります。
                </p>
              </div>
            </div>

            {/* 免責事項 */}
            <div className="pb-8 border-b border-[#e2e8f0]">
              <h2 className="text-2xl font-bold text-[#2d3748] mb-4">免責事項</h2>
              <div className="space-y-3">
                <ul className="space-y-3 ml-6">
                  <li className="flex items-start gap-2">
                    <div className="w-2 h-2 bg-[#2d3748] rounded-full flex-shrink-0 mt-2"></div>
                    <span className="text-[#4a5568]">Cloudflare Pages、microCMS等の外部サービスの障害や仕様変更により生じた損害については、当方は責任を負いかねます。</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <div className="w-2 h-2 bg-[#2d3748] rounded-full flex-shrink-0 mt-2"></div>
                    <span className="text-[#4a5568]">お客様が独自に行った変更・カスタマイズにより生じた不具合については、サポート対象外となります。</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <div className="w-2 h-2 bg-[#2d3748] rounded-full flex-shrink-0 mt-2"></div>
                    <span className="text-[#4a5568]">制作したサイトの運用により得られる成果（集客数、売上等）については、保証いたしかねます。</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <div className="w-2 h-2 bg-[#2d3748] rounded-full flex-shrink-0 mt-2"></div>
                    <span className="text-[#4a5568]">天災地変、その他不可抗力により納期が遅延した場合、当方は責任を負いかねます。</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* 著作権 */}
            <div className="pb-8 border-b border-[#e2e8f0]">
              <h2 className="text-2xl font-bold text-[#2d3748] mb-4">著作権</h2>
              <div className="space-y-3">
                <p className="text-[#4a5568]">
                  納品物の著作権は、ご入金確認後、お客様に帰属いたします。ただし、以下の点にご留意ください。
                </p>
                <ul className="space-y-2 ml-6">
                  <li className="flex items-start gap-2">
                    <div className="w-2 h-2 bg-[#2d3748] rounded-full flex-shrink-0 mt-2"></div>
                    <span className="text-[#4a5568]">使用した画像素材やフォント等の第三者著作物については、各ライセンスに従ってご利用ください。</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <div className="w-2 h-2 bg-[#2d3748] rounded-full flex-shrink-0 mt-2"></div>
                    <span className="text-[#4a5568]">制作実績として、当方のポートフォリオサイト等に掲載させていただく場合があります。</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* 表記の変更 */}
            <div>
              <h2 className="text-2xl font-bold text-[#2d3748] mb-4">表記の変更</h2>
              <p className="text-[#4a5568]">
                本表記の内容は、法令の改正や事業内容の変更等により、予告なく変更する場合があります。変更後の内容は、本ページに掲載した時点で効力を生じるものとします。
              </p>
            </div>
          </div>

          {/* 最終更新日 */}
          <div className="mt-16 pt-8 border-t border-[#e2e8f0]">
            <p className="text-sm text-[#4a5568]">最終更新日：2025年1月15日</p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-8 bg-[#f5f3f0]">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-[#2d3748] mb-6">ご不明な点がございましたら</h2>
          <p className="text-lg text-[#4a5568] mb-8">
            特定商取引法に関するご質問や、サービス内容についてのお問い合わせは、お気軽にご連絡ください。
          </p>
          <Link
            to="/"
            onClick={(e) => {
              e.preventDefault();
              window.REACT_APP_NAVIGATE('/');
              setTimeout(() => {
                const element = document.getElementById('contact');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }, 100);
            }}
            className="inline-block px-10 py-4 bg-[#1a2332] text-white rounded-full font-medium hover:bg-[#2d3748] transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            お問い合わせフォームへ
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1a2332] text-white py-20 px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
            {/* Left Column */}
            <div className="md:col-span-1">
              <div className="flex items-center gap-3 mb-6">
                <img 
                  src="https://public.readdy.ai/ai/img_res/4944a4ba-c62a-4964-bf85-4ed6714cc305.png" 
                  alt="Trim-Page Logo" 
                  className="w-10 h-10 object-contain"
                />
                <h3 className="text-3xl font-bold">Trim-Page</h3>
              </div>
              <p className="text-white/80 leading-relaxed mb-6">
                小規模店舗・個人事業主のための、月額費用のない静的サイト制作サービス
              </p>
              <div className="flex gap-4">
                {['ri-twitter-x-line', 'ri-facebook-circle-line', 'ri-instagram-line', 'ri-linkedin-box-line'].map((icon, index) => (
                  <a
                    key={index}
                    href="#"
                    className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-full hover:bg-white/10 transition-colors cursor-pointer"
                  >
                    <i className={`${icon} text-lg`}></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Middle Column */}
            <div>
              <h4 className="text-sm font-bold uppercase tracking-wider mb-6">Contact</h4>
              <div className="space-y-4">
                <div>
                  <p className="text-sm text-white/60 mb-1">メールアドレス</p>
                  <a href="mailto:info@trim-page.com" className="text-white hover:text-white/80 transition-colors">
                    info@trim-page.com
                  </a>
                </div>
                <div>
                  <Link
                    to="/"
                    onClick={(e) => {
                      e.preventDefault();
                      window.REACT_APP_NAVIGATE('/');
                      setTimeout(() => {
                        const element = document.getElementById('contact');
                        if (element) {
                          element.scrollIntoView({ behavior: 'smooth' });
                        }
                      }, 100);
                    }}
                    className="text-white underline hover:text-white/80 transition-colors cursor-pointer"
                  >
                    お問い合わせフォーム
                  </Link>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div>
              <h4 className="text-sm font-bold uppercase tracking-wider mb-6">Information</h4>
              <div className="space-y-4">
                <Link to="/about-operator" className="block text-white hover:text-white/80 transition-colors">
                  運営者情報
                </Link>
                <Link to="/tokushoho" className="block text-white hover:text-white/80 transition-colors">
                  特定商取引法に基づく表記
                </Link>
                <Link to="/privacy-policy" className="block text-white hover:text-white/80 transition-colors">
                  プライバシーポリシー
                </Link>
                <Link to="/support" className="block text-white hover:text-white/80 transition-colors">
                  サポートについて
                </Link>
              </div>
            </div>
          </div>

          <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-white/60">© 2025 Trim-Page. All rights reserved.</p>
            <div className="flex gap-6">
              <a href="#" className="text-sm text-white/60 hover:text-white transition-colors">
                利用規約
              </a>
              <a href="#" className="text-sm text-white/60 hover:text-white transition-colors">
                サイトマップ
              </a>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-sm text-white/60 hover:text-white transition-colors"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
